import { Component, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import {
  DefaultIntegrationImportParams,
  IntegrationImport,
  IntegrationImportOperation,
  IntegrationImportParams,
  IntegrationImportResult,
  IntegrationImportStatus
} from "../integration-imports.interface";
import {IntegrationsImportService} from "../integration.import.service";
import * as moment from "moment";
import {DatePickerService} from "../../../shared/services/date.picker.service";
import {SelectFilterEntry} from "../type-filter/entity";
import {IntegrationPlatformType} from "../../models/integration.model";
import {MatPaginator} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import {Store} from "@ngrx/store";
import {IState} from "../../../shared/models/state";
import {getIntegrationImportsDataSelector, getIntegrationImportsParamsSelector} from "../integration-imports.reducer";
import {GetIntegrationImportsAction} from "../integration-imports.actions";
import {ActivatedRoute} from "@angular/router";
import {Location} from "@angular/common";
import {DateFilterEvent} from "../../../shared/date-filter/date-filter.interface";
import {PageEvent} from "@angular/material/paginator/typings/paginator";

@Component({
  selector: 'cc-integration-imports',
  templateUrl: 'integration-imports.component.html',
  styleUrls: ['integration-imports.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class IntegrationImportsComponent implements OnInit, OnDestroy {
  public params: IntegrationImportParams;
  @Input() public dataSource: MatTableDataSource<IntegrationImport>;
  public total: number;
  public pageSizeOptions = [10, 20, 100];

  @ViewChild(MatPaginator) paginator: MatPaginator;

  public startDate: string | moment.Moment;
  public endDate: string | moment.Moment;
  public maxDate: string | moment.Moment;
  public minDate: string | moment.Moment;
  public opens: string;
  public datePickerOpened: boolean;

  public rows: IntegrationImport[];

  public keepFilters = false;

  public platforms: SelectFilterEntry[] = [
    { key: IntegrationPlatformType.SHOPIFY, translateKey: 'INTEGRATIONS.SHOPIFY.HEADER_TITLE' },
    { key: IntegrationPlatformType.PIPEDRIVE, translateKey: 'INTEGRATIONS.PIPEDRIVE.HEADER_TITLE' },
    { key: IntegrationPlatformType.LIVECHAT, translateKey: 'INTEGRATIONS.LIVECHAT.HEADER_TITLE' },
    { key: IntegrationPlatformType.MAGENTO, translateKey: 'INTEGRATIONS.MAGENTO.HEADER_TITLE' },
    { key: IntegrationPlatformType.SHOPER, translateKey: 'INTEGRATIONS.SHOPER.HEADER_TITLE' },
    { key: IntegrationPlatformType.HUBSPOT, translateKey: 'INTEGRATIONS.HUBSPOT.HEADER_TITLE' },
    { key: IntegrationPlatformType.ZENDESK, translateKey: 'INTEGRATIONS.ZENDESK.HEADER_TITLE' },
    { key: IntegrationPlatformType.ZAPIER, translateKey: 'INTEGRATIONS.ZAPIER.HEADER_TITLE' }
  ];

  public operations: SelectFilterEntry[] = [
    { key: IntegrationImportOperation.IMPORT, translateKey: 'INTEGRATIONS.IMPORT' },
    { key: IntegrationImportOperation.RESYNC, translateKey: 'INTEGRATIONS.RESYNC' },
    { key: IntegrationImportOperation.AUTO_RESYNC, translateKey: 'INTEGRATIONS.AUTO_RESYNC' }
  ];

  public statuses: SelectFilterEntry[] = [
    { key: IntegrationImportStatus.STARTED, translateKey: 'INTEGRATIONS.STATUS_TYPES.STARTED' },
    { key: IntegrationImportStatus.FAILED, translateKey: 'INTEGRATIONS.STATUS_TYPES.FAILED' },
    { key: IntegrationImportStatus.FINISHED, translateKey: 'INTEGRATIONS.STATUS_TYPES.FINISHED' }
  ];

  constructor(
    private integrationsImportService: IntegrationsImportService,
    private datePickerService: DatePickerService,
    private store: Store<IState>,
    private route: ActivatedRoute,
    public location: Location
  ) {}

  ngOnInit() {
    this.dataSource = new MatTableDataSource([]);
    this.keepFilters = this.route.snapshot.queryParamMap.get('keepFilters') === 'true';

    this.datePickerService.onTogglePicker.subscribe((open: { open: string; show: boolean }) => {
      this.opens = open && open.open ? open.open : 'left';
      this.datePickerOpened = open && open.show;
    });

    this.store.select(getIntegrationImportsDataSelector).subscribe((result: IntegrationImportResult) => {
      this.dataSource.data = result.data;
      this.total = result.total;
      this.paginator.length = result.total;
    });

    this.store.select(getIntegrationImportsParamsSelector).subscribe(params => {
      this.params = params;
      if (this.params && this.params.pager) {
        const { limit, page } = this.params.pager || ({} as any);
        this.paginator.pageSize = limit;
        this.paginator.pageIndex = page - 1;
      }
    });
    this.resetFiltersIfNeeded();
  }

  ngOnDestroy() {
    console.log('ngOnDestroy');
    this.resetFiltersIfNeeded();
  }

  private resetFiltersIfNeeded() {
    if (!this.keepFilters) {
      this.params = new DefaultIntegrationImportParams();
      this.store.dispatch(new GetIntegrationImportsAction(this.params));
    }
  }

  onDateFilterChange($event: DateFilterEvent) {
    this.params.dateFrom = $event.dateFrom;
    this.params.dateTo = $event.dateTo;
    this.store.dispatch(new GetIntegrationImportsAction(this.params));
  }

  onPlatformsChanged($event: any) {
    this.params.platforms = $event;
    this.store.dispatch(new GetIntegrationImportsAction(this.params));
  }

  onOperationsChanged($event: any) {
    this.params.operations = $event;
    this.store.dispatch(new GetIntegrationImportsAction(this.params));
  }

  onStatusesChanged($event: any) {
    this.params.statuses = $event;
    this.store.dispatch(new GetIntegrationImportsAction(this.params));
  }

  rejectedClicked(importId: number) {
    this.location.replaceState('/integrations/imports/list?keepFilters=true');
    this.keepFilters = true;
  }

  onPageChange(event: PageEvent) {
    this.params.pager = {
      limit: event.pageSize,
      page: event.pageIndex + 1
    };
    this.store.dispatch(new GetIntegrationImportsAction(this.params));
  }
}
